export default {
    methods: {
        onDragStart(evt) {
            const row = evt.item
            const table = row.closest('table')
            const colWidths = []

            Array.from(row.children).forEach((cell, index) => {
                colWidths[index] = cell.offsetWidth
            })

            table.querySelectorAll('tr').forEach(tr => {
                Array.from(tr.children).forEach((cell, index) => {
                    cell.style.width = `${colWidths[index]}px`
                })
            })
        },
        onDragEnd(evt) {
            const row = evt.item
            const table = row.closest('table')

            table.querySelectorAll('tr').forEach(tr => {
                Array.from(tr.children).forEach(cell => {
                    cell.style.width = ''
                })
            })
        }
    }
}